import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "./ui/motion";
import { journey, subscribeJourney } from "../journey/journeyState";
import { SECTIONS } from "../journey/sections";

/* The section name pinned in the corner of every page —
   driven by the journey's active index, so it works in both
   horizontal and vertical modes. */
export default function SectionRail() {
  const [label, setLabel] = useState(SECTIONS[0].label);

  useEffect(() => {
    return subscribeJourney(() => {
      const next = SECTIONS[journey.activeIndex]?.label ?? SECTIONS[0].label;
      setLabel((prev) => (prev === next ? prev : next));
    });
  }, []);

  return (
    <div className="fixed left-3 sm:left-5 top-1/2 -translate-y-1/2 z-40 hidden mdl:flex items-center gap-3 pointer-events-none select-none">
      <span className="h-8 w-px bg-paper/15" />
      <AnimatePresence mode="wait">
        <motion.span
          key={label}
          className="font-mono text-[10px] uppercase tracking-ultra text-zinc-500"
          style={{ writingMode: "vertical-rl", textOrientation: "mixed", transform: "rotate(180deg)" }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5, ease: EASE }}
        >
          {label}
        </motion.span>
      </AnimatePresence>
    </div>
  );
}
